import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the table bets report view.
 * @extends JetView
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Extend the summTreeColumn filter to include custom refresh logic
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summary display for a tree column.
                 * @param {Object} master - The master view containing the data.
                 * @param {Object} node - The node to update.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result accumulator
                    var resultFormat = 0; // Initialize formatted result
                    // Iterate through each data object in the master view
                    master.data.each(function (obj) {
                        // Sum values for objects at level 1
                        if (obj.$level == 1) result += obj[value.columnId];
                    });
                    // Format the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    // Update the inner HTML of the node with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            webix.ui.datafilter.summColumn, // Extend from the existing summColumn filter
        );
        // Return the configuration for the UI component
        return {
            rows: [
                {
                    id: 'preloader', // Identifier for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'treetable', // Identifier for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            scheme: {
                                $group: {
                                    by: 'UserName', // Group data by UserName
                                    map: {
                                        UserName: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                                        Amount: ['Amount', 'sum'], // Sum of Amount
                                        WinningAmount: ['WinningAmount', 'sum'], // Sum of WinningAmount
                                        Tax: ['Tax', 'sum'], // Sum of Tax
                                        WinningAmountTotal: [
                                            'WinningAmountTotal',
                                            'sum', // Sum of WinningAmountTotal
                                        ],
                                    },
                                },
                            },
                            columns: [
                                {
                                    id: 'UserName', // Column identifier for UserName
                                    header: _('UserName'), // Header text for UserName column
                                    width: 200, // Width of the column
                                    // Template function to display UserName or group total
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                                        return obj.UserName;
                                    },
                                    footer: 'Total:', // Footer text for UserName column
                                },
                                {
                                    id: 'detailTittle', // Column identifier for detail title
                                    header: '', // No header for this column
                                    width: 50, // Width of the column
                                    height: 25, // Height of the column
                                    tooltip: _('Detalles'), // Tooltip text for details
                                    // Template function to display detail icon based on level
                                    template: function (obj) {
                                        if (obj.$level == 1) {
                                            return '';
                                        } else {
                                            if (obj.$level == 2) {
                                                return "<span class='webix_icon wxi-close details'></span>";
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column identifier for Ticket Id
                                    header: _('Ticket Id'), // Header text for Ticket Id column
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                },
                                {
                                    id: 'UserId', // Column identifier for User Id
                                    header: _('Usuario'), // Header text for User Id column
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                },
                                {
                                    id: 'State', // Column identifier for State
                                    header: _('Estado'), // Header text for State column
                                    width: 80, // Width of the column
                                    options: [
                                        // Options for the State column
                                        { id: 'C', value: _('Abierto') },
                                        { id: 'S', value: _('Ganó') },
                                        { id: 'N', value: _('Perdió') },
                                        { id: 'A', value: _('No Acción') },
                                        { id: 'R', value: _('Pendiente') },
                                        { id: 'W', value: _('En Espera') },
                                        { id: 'J', value: _('Rechazada') },
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'),
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'),
                                        },
                                    ],
                                },
                                {
                                    id: 'Date', // Column identifier for Date
                                    header: _('Fecha'), // Header text for Date column
                                    width: 150, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                },
                                {
                                    id: 'DatePayment', // Column identifier for Payment Date
                                    header: _('Fecha de pago'), // Header text for Payment Date column
                                    width: 150, // Width of the column
                                },
                                {
                                    id: 'BetShopPayment', // Column identifier for Bet Shop Payment
                                    header: _('Punto Venta Pagó'), // Header text for Bet Shop Payment column
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                },
                                {
                                    id: 'Amount', // Column identifier for Amount
                                    header: _('Valor'), // Header text for Amount column
                                    format: webix.i18n.priceFormat, // Formatting function for Amount
                                    exportType: 'number', // Export type for Amount
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                    footer: { content: 'summTreeColumn' }, // Footer content for Amount column
                                },
                                {
                                    id: 'WinningAmount', // Column identifier for Winning Amount
                                    header: _('Premios'), // Header text for Winning Amount column
                                    format: webix.i18n.priceFormat, // Formatting function for Winning Amount
                                    exportType: 'number', // Export type for Winning Amount
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                    footer: { content: 'summTreeColumn' }, // Footer content for Winning Amount column
                                },
                                {
                                    id: 'Tax', // Column identifier for Tax
                                    header: _('Impuesto Premios'), // Header text for Tax column
                                    format: webix.i18n.priceFormat, // Formatting function for Tax
                                    exportType: 'number', // Export type for Tax
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                    footer: { content: 'summTreeColumn' }, // Footer content for Tax column
                                },
                                {
                                    id: 'TaxBet', // Column identifier for Tax on Bet
                                    header: _('Impuesto Apuesta'), // Header text for Tax on Bet column
                                    format: webix.i18n.priceFormat, // Formatting function for Tax on Bet
                                    exportType: 'number', // Export type for Tax on Bet
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                    footer: { content: 'summTreeColumn' }, // Footer content for Tax on Bet column
                                },
                                {
                                    id: 'WinningAmountTotal', // Column identifier for Total Winning Amount
                                    header: _('Premio Total'), // Header text for Total Winning Amount column
                                    format: webix.i18n.priceFormat, // Formatting function for Total Winning Amount
                                    exportType: 'number', // Export type for Total Winning Amount
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                    footer: { content: 'summTreeColumn' }, // Footer content for Total Winning Amount column
                                },
                                {
                                    id: 'Odds', // Column identifier for Odds
                                    header: _('Odds'), // Header text for Odds column
                                    width: 100, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                },
                                {
                                    id: 'UserIP', // Column identifier for User IP
                                    header: _('IP'), // Header text for User IP column
                                    width: 120, // Width of the column
                                    sort: 'int', // Sorting type for the column
                                },
                                {
                                    id: 'Wallet', // Column identifier for Wallet
                                    header: _('Billetera'), // Header text for Wallet column
                                    width: 100, // Width of the column
                                },
                            ],
                            // Event handler for clicking on details icon
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [
                                        item.Id, // Trigger event with the item Id
                                    ]);
                                    // Show or expand details based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('filterDetails').show();
                                        $$('filterDetails2').show();
                                    } else {
                                        $$('dColl').expand();
                                        $$('a5').scrollTo(0, 1000);
                                    }
                                },
                            },
                            tooltip: true, // Enable tooltips for the table
                            footer: true, // Enable footer for the table
                            math: true, // Enable mathematical operations for the table
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                            pager: 'pagerA', // Identifier for the pager component
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component for the treetable
        grid = $$('treetable');

        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);

        // Construct the base URL for fetching bet history
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistory?FromId=' + cur_user + '&';

        // Initialize an empty filter string
        var filter = '';

        // Set up an event listener for the 'betsReport:filter' event
        this.on(this.app, 'betsReport:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';

            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and is not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range selection
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle single date selection
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Handle date format without time
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle filter values that are objects
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle end date
                                if (object2[j][0] === 'end') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle start date
                                    if (object2[j][0] === 'start') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;

            // Clear the grid data before loading new data
            grid.clearAll();

            // Load the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);

            // Hide the filter popup after applying the filter
            $$('filterPopup').hide();

            // Update the filter variable with the current filter string
            filter = string1;
        });

        // Attach an event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid with the sorted data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Set up an event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            // Load the grid with data for the selected player
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
